import React, { Component } from 'react';

const android = process.env.PUBLIC_URL + '/img/android.png';
const ios = process.env.PUBLIC_URL + '/img/ios.png';
const windows = process.env.PUBLIC_URL + '/img/windows.png';
const web = process.env.PUBLIC_URL + '/img/web.svg';
const desktop = process.env.PUBLIC_URL + '/img/desktop.png';
const linux = process.env.PUBLIC_URL + '/img/linux.png';
const reactImg = process.env.PUBLIC_URL + '/img/react.svg';
const cordova = process.env.PUBLIC_URL + '/img/cordova.svg';
const html5 = process.env.PUBLIC_URL + '/img/html5.svg';
const node = process.env.PUBLIC_URL + '/img/node.svg';
const unity = process.env.PUBLIC_URL + '/img/unity.png';
const electron = process.env.PUBLIC_URL + '/img/electron.svg';
import globalizacao from '../escolha/globalizacao';
const git = process.env.PUBLIC_URL + '/img/git.svg';
const aws = process.env.PUBLIC_URL + '/img/aws.svg';

class HomeTecnologias extends Component {
    render() {
        return (
            <section className="secao tecnologia-utilizada fundo-white">
                <div className="limite conteudo">
                    <h2>{globalizacao.msg("solucoesCross")}</h2>
                    <p>
                        {globalizacao.msg('tecnologiaUsada')}
                    </p>

                    <ul className="lista lista-platform">
                        <li>  <img src={android} alt="android" title="android" /></li>
                        <li> <img src={ios} alt="ios" title="ios" /></li>
                        <li> <img src={windows} alt="windows" title="windows" /></li>
                        <li> <img src={linux} alt="linux" title="linux" /></li>
                        <li> <img src={web} alt="web" title="web" /></li>
                        <li> <img src={desktop} alt="desktop" title="desktop" /></li>
                    </ul>

                    <h2> {globalizacao.msg("tecnologia")} </h2>
                    <p>
                        {globalizacao.msg("tecnologiaEquipe")}
                    </p>
                    <ul className="lista lista-platform">
                        <li>  <img src={reactImg} alt="react" title="react" /></li>
                        <li> <img src={node} alt="nodejs" title="nodejs" /></li>
                        <li> <img src={html5} alt="html5" title="html5" /></li>
                        <li> <img src={git} alt="git" title="git" /></li>
                        <li> <img src={aws} alt="aws" title="Amazon Web Services" /></li>

                    </ul>
                </div>
            </section>

        );
    }
}

export default HomeTecnologias;
